module.exports = __webpack_public_path__ + "img/snatch_word_yellow.8b5f3a07.png";